import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { Fragment } from 'react/jsx-runtime';
import { flags } from '@/feature-flags/flags.ts';
import { useFeatureFlags } from '@/feature-flags/use-feature-flags.ts';
import { useAppLoader } from '../../loader.ts';
import { useAuthInfo } from '../../use-auth-info.ts';
import { menuActions } from './menu-actions.tsx';
import { menu } from './menu.css.ts';
import { MoreMenu } from './more-menu.tsx';

const mobileMenuActions = [
  menuActions.Home,
  menuActions.Search,
  menuActions.Notifications,
  <MoreMenu key="more" />,
  menuActions.GuestAuth,
];

const tabletMenuActions = [
  menuActions.Home,
  menuActions.Marketplace,
  menuActions.Terminal,
  menuActions.StreamDeck,
  menuActions.LearningCenter,
  menuActions.Tools,
  menuActions.Notifications,
  menuActions.Enterprise,
  menuActions.Report,
  menuActions.Charts,
  menuActions.Sources,
  menuActions.Admin,
];

const filterMenuActions = ({
  actions,
  authenticated,
  isAdmin,
  chartsEnabled,
}: {
  actions: typeof tabletMenuActions;
  authenticated: boolean;
  isAdmin: boolean;
  chartsEnabled: boolean;
}) =>
  actions.filter((action) => {
    if (action === menuActions.GuestAuth) return !authenticated;
    if (action === menuActions.Admin) return isAdmin;
    if (action === menuActions.Sources) return isAdmin;
    if (action === menuActions.Charts) return authenticated && chartsEnabled;
    return true;
  });

export const Menu = () => {
  const isTablet = useIsTablet();
  const { authenticated } = useAppLoader();
  const { isAdmin } = useAuthInfo();
  const chartsEnabled = useFeatureFlags(flags.streamTimeSeries);

  const actions = filterMenuActions({
    actions: isTablet ? tabletMenuActions : mobileMenuActions,
    authenticated,
    isAdmin,
    chartsEnabled,
  });

  return (
    <div className={menu}>
      {actions.map((action, index) => (
        <Fragment key={index}>{action}</Fragment>
      ))}
    </div>
  );
};
